module.exports = __webpack_public_path__ + "static/media/orange3.81adf289.png";